import React, { ReactNode } from 'react'

import { Calendar } from 'antd'
import { CalendarProps } from 'antd'
import moment, { Moment } from 'moment'

// interface CalendarProps {
//   fullscreen?: boolean;
//   locale: object;
//   value?: Moment;
//   onSelect?: (date?: moment.Moment | undefined) => void;
//   onChange?: (date?: moment.Moment | undefined) => void;
//   dateCellRender?: (data: moment.Moment) => ReactNode | undefined;
//   monthCellRender?: (data: moment.Moment) => ReactNode | undefined;
// }

const Display = (props: CalendarProps<any>) => {
  return <Calendar {...props} value={props.value ? props.value : moment()} />
}

export default Display
